import useAuth from 'hooks/useAuth';
import useUser from 'hooks/useUser';

export default function useTimezone() {
  const { userId } = useAuth();
  const { user } = useUser(userId);

  return { timezone: user?.settings?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone };
}
